import { HookResult, StateService, Transition, UIRouter } from "@uirouter/angular";
import { TrackingService } from "../services/tracking.service";

export function dataCollectionConfigFn(router: UIRouter) {
    router.transitionService.onFinish({ to: $state => $state.includes.ng2Root }, _collectStateData);
}

/**
 * Handles the collection of data related to the state being activated.
 */
function _collectStateData(transition: Transition): HookResult {
    const tranking = transition.injector().get<TrackingService>(TrackingService);
    const $state = transition.injector().get<StateService>(StateService);
    const target = transition.targetState();
    const toState = target.state();
    const fromState = transition.from();
    tranking.setPageData(
        toState.name,
        (toState.data && toState.data.pageTitle) ? toState.data.pageTitle : "",
        $state.href(toState, target.params(), { absolute: true }),
        toState.url,
        (fromState.data && fromState.data.pageTitle) ? fromState.data.pageTitle : "",
        (fromState.url === "/logincallback") ? "" : fromState.url,
        toState.data?.section || "",
        toState.data?.subSection || ""
    );
}

